<template>
  <!-- 赠品 -->
  <!-- con_pad_l 失效时去掉 -->
  <div
    :class="{
      border_top1px: showLine,
      con_pad_l: freeProduct.status !== 0
    }"
    class="free_con"
  >
    <div class="content clearfix">
      <div
        v-if="freeProduct.status === 0"
        class="none_icon left font10 font_weight400 colof line_height_14"
      >
        失效
      </div>
      <div class="left product_img">
        <img
          :src="freeProduct.skuPic"
          alt=""
          class="img_img"
          @click="goProductDetail(freeProduct.spuId)"
        />
        <img
          src="@/assets/product/icon_right_free@2x.png"
          alt=""
          class="img_icon"
        />
      </div>
      <div class="name left text_left font_weight400">
        <div class="font12 colo0 name_name">
          {{ freeProduct.skuName }}
        </div>
        <div class="name_spec clearfix">
          <div
            :class="{ spec_bg: 0 }"
            class="left spec_det font10 text_left font_weight400 colo055 line_height_16 font_line_1"
          >
            规格：{{ freeProduct.skuSpec }}
          </div>
          <img
            src="@/assets/common/icon_cell_more_24@2x.png"
            alt=""
            class="left more_icon"
            v-if="showBor"
          />
        </div>
      </div>
      <div class="right">
        <div class="font16 font_weight600 colo087 line_height_19 free_price">
          {{ freeProduct.price | currency(false) }}
        </div>
        <div class="font12 font_weight400 colo087 line_height_14">
          ×{{ freeProduct.amount }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    freeProduct: {
      type: Object,
      default() {
        return {};
      }
    },
    showBor: {
      type: Boolean,
      default: false
    },
    showLine: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: true
    };
  },
  methods: {
    close() {
      this.show = true;
      this.$emit("closeSheet");
    },
    goProductDetail(spuId) {
      this.$emit("goProductDetail", spuId);
    }
  }
};
</script>

<style lang="less" scoped>
.con_pad_l {
  padding-left: 30px;
}
.free_con {
  background: #fff;
  padding-right: 30px;
  // border: 0;
  .content {
    padding: 12px 0 0;
    .none_icon {
      background: rgba(0, 0, 0, 0.38);
      border-radius: 2px;
      padding: 4px 1px;
      margin: 17px 10px 0 0;
    }
    .btn {
      background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
      border-radius: 20px;
      margin-top: 135px;
    }
    .free_pad {
      padding-bottom: 12px;
    }
    .icon_free {
      width: 32px;
      margin-right: 8px;
    }
    .product_img {
      width: 56px;
      height: 56px;
      position: relative;
      font-size: 0;
      .img_img {
        width: 100%;
      }
      .img_icon {
        position: absolute;
        top: 0;
        left: 0;
        width: 31px;
      }
    }
    .name {
      padding: 4px 0 0 8px;
      .name_name {
        width: 152px;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .name_det {
        padding-top: 13px;
      }
    }
    .name_spec {
      margin-top: 11px;
      .spec_det {
        max-width: 90px;
        overflow-y: hidden;
      }
      .spec_bg {
        background: rgba(0, 0, 0, 0.03);
        border-radius: 2px;
      }
      .more_icon {
        width: 16px;
      }
      .delete_icon {
        width: 16px;
      }
    }
  }
  .free_price {
    margin: 22px 0 7px;
  }
}
</style>
